import _objectSpread from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import Dialog from '@/components-v2/v2-dialog/index';
import debounce from "lodash/debounce";
import PageTop from "@/components-v2/layout/page-top";
import PageTop1 from "@/components-v2/layout/page-top1";
import PageBottom from "@/components-v2/layout/page-bottom";
import { Countdown } from "@/components-v2/countdown";
import publicMethods from '@mixin/publicMethods';
import { AccountStorage } from "@services/account";
var accountStorage = new AccountStorage();
export default {
  components: {
    Dialog: Dialog,
    PageBottom: PageBottom,
    Countdown: Countdown,
    PageTop: PageTop,
    PageTop1: PageTop1
  },
  data: function data() {
    return {
      id: "",
      type: "order",
      orderDetail: {},
      serialNumber: "",
      createQrCodeUrlPrefix: "/pjyy-deepexi-aggregation/api/v1/qrcode/getQrCode",
      bill: {
        data: {}
      },
      order: {
        data: {}
      },
      payment: {
        list: {},
        mode: ""
      },
      countDown: {
        show: false,
        value: 0
      },
      qrCodeModal: {
        show: false,
        overtime: 60,
        regetShow: false,
        qrCodeUrl: ""
      },
      payUrl: "",
      act_str: "",
      act_money: "",
      actIndex: 0,
      userInfo: {},
      showDebt: false,
      //欠款弹窗
      arrearsData: {},
      //欠款信息
      currentTitle: "",
      expandOrNot: false,
      // 是否展开
      paymentData: {},
      // 保存支付的数据
      orderAmountInfo: {} // 订单金额信息
    };
  },
  mixins: [publicMethods],
  created: function created() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var params, id, type;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            params = _this.$route.query;
            id = params.orderId;
            type = params.type;
            _this.id = id;
            type && (_this.type = type);
            _this.userInfo = accountStorage.getCacheUserInfo();
            _context.next = 8;
            return _this.initPayMode();
          case 8:
            if (!(type === "bill")) {
              _context.next = 13;
              break;
            }
            _context.next = 11;
            return _this.initBillDetailData();
          case 11:
            _context.next = 15;
            break;
          case 13:
            _context.next = 15;
            return _this.initOrderDetailData();
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    this.stopCheckOrderPayStatus();
    this.clearRegetQrCodeTimeout();
  },
  methods: {
    //复制卡号
    copyCode: function copyCode(item, val1) {
      // 创建输入框元素
      var oInput = document.createElement('input');
      // 将想要复制的值
      oInput.value = item.account;
      if (item.recommend == 1) {
        oInput.value += val1;
      }
      // 页面底部追加输入框
      document.body.appendChild(oInput);
      // 选中输入框
      oInput.select();
      // 执行浏览器复制命令
      document.execCommand('Copy');
      // 弹出复制成功信息
      this.$messageTip("账户复制成功！", 'success');
      // 复制后移除输入框
      oInput.remove();
    },
    //模式tab切换
    tabChange: function tabChange(str, index) {
      this.actIndex = index;
      if (this.actIndex === 0) {
        this.payment.list.immediatePayment.checked = true;
        this.payment.list.offlinePayment.checked = false;
      } else {
        this.payment.list.immediatePayment.checked = false;
        this.payment.list.offlinePayment.checked = true;
      }
      this.$forceUpdate();
    },
    //支付渠道选择
    choosePayWay: function choosePayWay(item, title) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2.currentTitle = title;
              _this2.payment.mode = item.code;
              _this2.paymentData = {
                id: item.id,
                code: item.code,
                type: item.type,
                promotionId: item.promotionId,
                // 文案号
                name: item.name
              };
              if (item.name === '找朋友付') {
                _this2.findAFriendToPay(_this2.order.data.orderNumber, _this2.payment.list.tatil, true);
              } else {
                _this2.payment.list.immediatePayment.checked = true;
                _this2.payment.list.offlinePayment.checked = false;
                if (_this2.type === 'order') {
                  _this2.getOrderAmountInfo();
                }
              }
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // 查询金额
    getOrderAmountInfo: function getOrderAmountInfo() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var params, api, res, _res$data, code, data;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              params = _this3.paymentData;
              params.payType = 'ONLINE';
              params.orderNumber = _this3.id;
              api = '/pjyy-deepexi-order-center/rpc/v3/order/OcOrder/getOrderAmount';
              _context3.next = 6;
              return _this3.$getHttpClient().post(api, params);
            case 6:
              res = _context3.sent;
              _res$data = res.data, code = _res$data.code, data = _res$data.data;
              if (code == 200) {
                _this3.orderAmountInfo = data || {};
              }
            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    //获取活动提示
    getPayActTip: function getPayActTip() {
      var tip = "";
      if (this.payment.list && this.payment.list.immediatePayment && this.payment.list.immediatePayment.addedTitle) {
        var percent = this.payment.list.immediatePayment.addedTitle;
        tip = "\u6D3B\u52A8\u671F\u95F4\uFF0C\u7EBF\u4E0A\u652F\u4ED8\u7ACB\u51CF".concat(percent, "\u2030");
      }
      if (this.order.whetherCashCustomer) {
        if (tip.length > 0) {
          tip += ",";
        }
        //现金客户
        tip += "*线上支付：完成支付后再发货。";
      }
      return tip;
    },
    clearRegetQrCodeTimeout: function clearRegetQrCodeTimeout() {
      clearTimeout(this.regetQrCodeTimer);
    },
    createRegetQrCodeTimeout: function createRegetQrCodeTimeout() {
      var _this4 = this;
      this.clearRegetQrCodeTimeout();
      if (this.qrCodeModal.overtime > 0) {
        this.regetQrCodeTimer = setTimeout(function () {
          _this4.clearRegetQrCodeTimeout();
          _this4.qrCodeModal.overtime -= 1;
          _this4.createRegetQrCodeTimeout();
        }, 1000);
      } else {
        this.qrCodeModal.regetShow = true;
      }
    },
    // 跳转到账单列表页
    goToBillListPage: function goToBillListPage() {
      this.$router.replace({
        name: "billList",
        params: {
          status: "0"
        }
      });
    },
    // 跳转到订单列表页
    goToOrderListPage: function goToOrderListPage() {
      this.$router.replace({
        name: "v2-order",
        params: {
          status: "0"
        }
      });
    },
    // 跳转到支付成功页
    goToPaymentSuccessPage: function goToPaymentSuccessPage() {
      this.$router.replace({
        name: "v2-payresult",
        params: {
          payType: "SUCCESS",
          orderId: this.id
        }
      });
    },
    // 关闭支付弹框
    closePayModal: function closePayModal() {
      this.stopCheckOrderPayStatus();
      this.clearRegetQrCodeTimeout();
      this.qrCodeModal.show = false;
    },
    // 停止检查订单支付状态
    stopCheckOrderPayStatus: function stopCheckOrderPayStatus() {
      clearInterval(this.order.payStatusInterval);
      this.order.payStatusInterval = null;
    },
    // 开始检查订单支付状态
    startCheckOrderPayStatus: function startCheckOrderPayStatus() {
      var _this5 = this;
      this.order.payStatusInterval = setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var result;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this5.pullPaymentStatus();
            case 2:
              result = _context4.sent;
              if (result.data.code == "200") {
                // const payStatus = result.data.data;
                // if (payStatus) {
                _this5.stopCheckOrderPayStatus();
                _this5.clearRegetQrCodeTimeout();
                _this5.goToPaymentSuccessPage();
                // }
              } else if (result.data.code == "309") {} else if (result.data.code == "310") {
                _this5.stopCheckOrderPayStatus();
                _this5.clearRegetQrCodeTimeout();
                _this5.$confirm('银行到账信息略有延迟，超5分钟支付状态未变更，请联系 业务员：' + _this5.payment.list.name + "，电话：" + _this5.payment.list.phone, '银行到账信息确认中……', {
                  confirmButtonText: '确定',
                  showCancelButton: false,
                  //是否显示取消按钮
                  showClose: false,
                  //是否显示关闭按钮
                  closeOnClickModal: false,
                  //是否可以通过点击空白处关闭弹窗
                  type: 'info'
                }).then(function () {
                  // 成功
                  _this5.goToOrderListPage();
                }).catch(function () {
                  // 失败
                  _this5.goToOrderListPage();
                });
              } else {
                _this5.stopCheckOrderPayStatus();
                _this5.clearRegetQrCodeTimeout();
              }
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      })), 2000);
    },
    // 停止检查账单支付状态
    stopCheckBillPayStatus: function stopCheckBillPayStatus() {
      clearInterval(this.bill.payStatusInterval);
    },
    // 开始检查账单支付状态
    startCheckBillPayStatus: function startCheckBillPayStatus() {
      var _this6 = this;
      this.bill.payStatusInterval = setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var result, payStatus;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this6.pullPaymentStatus();
            case 2:
              result = _context5.sent;
              if (result.data.code === "200") {
                payStatus = result.data.data;
                if (payStatus) {
                  _this6.stopCheckBillPayStatus();
                  _this6.clearRegetQrCodeTimeout();
                  _this6.goToPaymentSuccessPage();
                }
              }
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      })), 2000);
    },
    // 拉取订单/账单支付状态
    pullPaymentStatus: function pullPaymentStatus() {
      return this.$getHttpClient({
        useSpinner: false,
        useResponseToast: false
      }).get("/pjyy-deepexi-pay-center/pay/v2/PublicPay/queryOrder?orderNumber=" + this.id + "&orderType=1");
    },
    // 倒计时停止跳转到订单列表
    countDownStopHandler: function countDownStopHandler() {
      this.stopCheckOrderPayStatus();
      this.clearRegetQrCodeTimeout();
      this.goToOrderListPage();
    },
    // 拉取订单详情
    pullOrderDetailData: function pullOrderDetailData() {
      return this.$getHttpClient().get("/pjyy-deepexi-order-center/api/v1/order/OcOrderLine/orderLineList", {
        params: {
          orderNumber: this.id
        }
      }).then(function (responses) {
        var data = responses.data;
        if (data.code === "200") {
          return data.data;
        }
      });
    },
    // 初始化订单详情信息
    initOrderDetailData: function initOrderDetailData() {
      var _this7 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var result;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _this7.pullOrderDetailData();
            case 2:
              result = _context6.sent;
              if (result) {
                _this7.order.data = result;
                _this7.countDown.value = Math.floor(result.closeTime / 1000) + 1;
                _this7.countDown.show = true;
              }
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    // 拉取账单详情
    pullBillDetailData: function pullBillDetailData() {
      return this.$getHttpClient().post("/pjyy-deepexi-order-center/api/v1/bill/viewBill", {
        documentNo: this.id
      }).then(function (responses) {
        var data = responses.data;
        if (data.code === "200") {
          return data.data;
        }
      });
    },
    // 初始化账单详情信息
    initBillDetailData: function initBillDetailData() {
      var _this8 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var result;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return _this8.pullBillDetailData();
            case 2:
              result = _context7.sent;
              if (result) {
                _this8.bill.data = result;
              }
            case 4:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    // 拉取订单支付二维码信息
    pullOrderQrCodeData: function pullOrderQrCodeData() {
      var _this9 = this;
      var useSpinner = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var data = {
        orderSource: 5,
        orderOrErpId: this.id,
        orderType: 2,
        environment: 2,
        titleName: "普健医药商城",
        companyId: this.userInfo.loginCompanyId,
        payChannel: this.payment.mode,
        payMode: this.payment.mode,
        payType: this.payment.mode == "ALIPAY" ? 2 : this.payment.mode == "WXPAY" ? 1 : 0,
        tagId: accountStorage.getCacheUserInfo().account,
        payCode: "CTOB",
        transTerminalType: 1,
        //pc端
        transChannelType: 1 //pc端
      };
      return this.$getHttpClient({
        useSpinner: useSpinner,
        useResponseToast: false
      }).post("/pjyy-deepexi-pay-center/pay/v2/PublicPay/payOrder", data).then(function (responses) {
        var data = responses.data;
        if (data.code == "200") {
          return data.data;
        } else {
          _this9.$toast.mount(_this9.$toast.create(data.msg, {
            unmounted: function unmounted() {
              _this9.goToOrderListPage();
            }
          }));
        }
      });
    },
    // 拉取账单支付二维码信息
    pullBillQrCodeData: function pullBillQrCodeData() {
      var _this10 = this;
      var useSpinner = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var loginCompanyId = accountStorage.getCacheUserInfo().loginCompanyId;
      var data = {
        companyId: loginCompanyId,
        documentNo: this.id,
        payChannel: this.payment.mode,
        payType: "NATIVE",
        titleName: "普健医药商城"
      };
      return this.$getHttpClient({
        useSpinner: useSpinner,
        useResponseToast: false
      }).post("/pjyy-deepexi-pay-center/api/v1/bill/pay", data).then(function (responses) {
        var data = responses.data;
        if (data.code === "200") {
          return data.data;
        } else {
          _this10.$toast.mount(_this10.$toast.create(data.msg, {
            unmounted: function unmounted() {
              _this10.goToBillListPage();
            }
          }));
        }
      });
    },
    //创建农商行表单提交
    createForm: function createForm(res) {
      var responseData = {
        orig: res.orig,
        sign: res.sign,
        returnurl: res.returnurl,
        informurl: res.informurl,
        transName: res.transName,
        repeatInform: res.repeatInform
      };
      // 根据返回的数据创建隐藏的表单元素
      var form = document.createElement('form');
      form.action = res.url; // 替换为实际的action值
      form.method = 'post';
      if (form && document.body) {
        for (var key in responseData) {
          if (responseData.hasOwnProperty(key)) {
            var input = document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            input.value = responseData[key]; // 使用接口返回的值设置input的值
            form.appendChild(input);
          }
        }

        // 添加提交按钮
        var submitBtn = document.createElement('input');
        submitBtn.type = 'submit';
        submitBtn.name = 'submitBtn';
        submitBtn.value = '正在跳转重庆农村商业银行，请稍等...'; // 替换为实际的提交按钮值
        form.appendChild(submitBtn);
        // 将表单添加到DOM中
        document.body.appendChild(form);
        // 模拟表单提交
        var HTMLFormElementSubmit = function (form) {
          return function () {
            try {
              var newWindow = window.open('', '_blank'); // 打开新的空白标签页
              newWindow.document.write(form.outerHTML); // 在新窗口中写入表单HTML
              if ('submit' in form) {
                newWindow.document.forms[0].submit(); // 提交表单
                // 提交完毕后删除表单
                form.parentNode.removeChild(form);
              } else {
                newWindow.document.forms[0].dispatchEvent(new Event('submit', {
                  bubbles: true
                }));
              }
            } catch (error) {
              console.error(error);
            }
          };
        }(form);
        HTMLFormElementSubmit();
      } else {
        console.error('form or document.body is null');
      }
    },
    // 初始化支付二维码信息
    initQrCodeInfo: function initQrCodeInfo() {
      var _arguments = arguments,
        _this11 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var useSpinner, result;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              useSpinner = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : true;
              result = {}; // if (this.type === "bill") {
              //   result = await this.pullBillQrCodeData(useSpinner);
              // } else {
              _context8.next = 4;
              return _this11.pullOrderQrCodeData(useSpinner);
            case 4:
              result = _context8.sent;
              // }

              if (result) {
                if (result.payChannel == "CQNCSYPAY") {
                  _this11.createForm(result.object);
                  _this11.startCheckOrderPayStatus();
                } else {
                  _this11.startCheckOrderPayStatus();
                  if (_this11.payment.mode != "ALIPAY" && _this11.payment.mode != "WXPAY") {
                    window.open(result.object.url);
                  } else {
                    _this11.qrCodeModal.qrCodeUrl = result.object.url;
                    _this11.qrCodeModal.regetShow = false;
                    _this11.qrCodeModal.overtime = 60;
                    _this11.qrCodeModal.show = true;
                    // this.createRegetQrCodeTimeout();
                  }
                }
              }
              return _context8.abrupt("return", result);
            case 7:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    // 拉取支付方式
    pullPayMode: function pullPayMode() {
      return this.$getHttpClient().get("/pjyy-deepexi-pay-center/pay/v2/PublicPay/getpayInfoPage?orderType=" + this.type + "&orderNumber=" + this.id + "&code=" + this.userInfo.account + "&staffCode=" + this.userInfo.staffCode + "&channelType=3").then(function (responses) {
        var data = responses.data;
        if (data.code == "200") {
          return data.data;
        }
      });
    },
    // 初始化支付方式
    initPayMode: function initPayMode() {
      var _this12 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var result;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return _this12.pullPayMode();
            case 2:
              result = _context9.sent;
              if (result) {
                // this.payment.mode = result.immediatePayment.defaultPay;
                if (result.immediatePayment.show && result.offlinePayment.show) {
                  if (result.offlinePayment.payName == "COD") {
                    result.immediatePayment.checked = true;
                    result.offlinePayment.checked = false;
                    _this12.actIndex = 0;
                  } else if (result.offlinePayment.payName == "OFFLINEPAY") {
                    //如果是线下付款 默认选中
                    result.immediatePayment.checked = false;
                    result.offlinePayment.checked = true;
                    _this12.actIndex = 1;
                  }
                } else if (result.immediatePayment.show && !result.offlinePayment.show) {
                  result.immediatePayment.checked = true;
                  _this12.actIndex = 0;
                } else if (!result.immediatePayment.show && result.offlinePayment.show) {
                  result.offlinePayment.checked = true;
                  _this12.actIndex = 1;
                }
                _this12.payment.list = result;
              }
            case 4:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    // 刷新二维码
    regetQrCode: function regetQrCode() {
      var _this13 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return _this13.initQrCodeInfo(false);
            case 2:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    // 去支付
    toPayModal: debounce( /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(e) {
        var params, url, result, data;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              if (!(this.actIndex === 0 && !this.payment.mode)) {
                _context11.next = 3;
                break;
              }
              this.$messageTip("请选择支付方式！", 'error');
              return _context11.abrupt("return");
            case 3:
              if (!this.order.payStatusInterval) {
                _context11.next = 6;
                break;
              }
              this.$messageTip("当前正在支付中，请等待支付完成！", 'error');
              return _context11.abrupt("return");
            case 6:
              params = _objectSpread(_objectSpread({
                orderNumber: this.id
              }, this.paymentData), {}, {
                payType: e
              });
              if (e == "OFFLINE") {
                params.name = this.payment.list.offlinePayment.payName;
              }
              url = "/pjyy-deepexi-order-center/rpc/v3/order/OcOrder/updateOrder";
              _context11.next = 11;
              return this.$getHttpClient().post(url, params);
            case 11:
              result = _context11.sent;
              data = result.data;
              if (!(data.code == '200')) {
                _context11.next = 26;
                break;
              }
              if (!(this.type == "order")) {
                _context11.next = 23;
                break;
              }
              if (!(this.actIndex === 0)) {
                _context11.next = 20;
                break;
              }
              _context11.next = 18;
              return this.initQrCodeInfo();
            case 18:
              _context11.next = 21;
              break;
            case 20:
              if (typeof data.payload != 'undefined') {
                if (data.payload.statusCode === 5) {
                  this.arrearsData = data.payload;
                  this.showDebt = true;
                }
              } else {
                this.goToPaymentSuccessPage();
              }
            case 21:
              _context11.next = 26;
              break;
            case 23:
              if (!(this.type == "bill")) {
                _context11.next = 26;
                break;
              }
              _context11.next = 26;
              return this.initQrCodeInfo();
            case 26:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }(), 500)
  }
};